import { Environment } from '../app/shared/model/environment/environment';

export const environment: Environment = {
  production: false,
  playground: true,
  brokerURLSuffix: 'api/wsregistry',
};
